import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC, useEffect, useState } from 'react'
import { ReactPlayer } from '../../../../../../components/ReactPlayer/ReactPlayer'
import { theme } from '@dtx-company/shared-components/src'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'

interface FlowlyticsVideoProps {
  videoLink: string | string[] | MediaStream | undefined
  videoCallback?: () => void
  playing?: boolean
}

export const FlowlyticsVideo: FC<FlowlyticsVideoProps> = ({
  videoLink,
  videoCallback,
  playing
}) => {
  const [isVideoReady, setIsVideoReady] = useState(false)
  const [isPlaying, setIsPlaying] = useState(false)

  useEffect(() => {
    if (!playing) {
      setIsPlaying(false)
    }
  }, [playing])

  return (
    <Box
      width="100%"
      height="100%"
      backgroundColor={theme.colors.primary.black}
      border={`0.5px solid ${theme.colors.primary.black}`}
      borderRadius={'12px'}
      position="relative"
    >
      {!isVideoReady && (
        <SkeletonTheme
          baseColor={theme.colors.masterWeb.grey8}
          highlightColor={theme.colors.masterWeb.grey7}
        >
          <Skeleton
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              width: '100%',
              height: '100%'
            }}
          />
        </SkeletonTheme>
      )}
      <ReactPlayer
        url={videoLink}
        width="100%"
        height="100%"
        config={{
          vimeo: {
            playerOptions: {
              controls: true,
              playsInline: true,
              responsive: true,
              pip: true
            }
          }
        }}
        playing={isPlaying}
        onReady={() => setIsVideoReady(true)}
        onPlay={() => {
          setIsPlaying(true)
          videoCallback?.()
        }}
        style={{
          display: isVideoReady ? 'block' : 'hidden',
          background: 'transparent',
          overflow: 'hidden',
          borderRadius: '12px'
        }}
      />
    </Box>
  )
}
